import { render, staticRenderFns } from "./AppBush.vue?vue&type=template&id=3162b46a&scoped=true&"
import script from "./AppBush.vue?vue&type=script&lang=js&"
export * from "./AppBush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162b46a",
  null
  
)

export default component.exports